import type { DriveSourceKindValue } from '@vivport/backend/types';
import type { IntegrationKind } from '../integrations/integration-kinds';

export const SOURCE_KIND_META: Record<DriveSourceKindValue, { kind: IntegrationKind; label: string }> = {
  MICROSOFT: { kind: 'microsoft-tenant', label: 'Microsoft 365' },
  RELAY: { kind: 'relay', label: 'On-premises relay' },
  GOOGLE: { kind: 'google-drive', label: 'Google Drive' },
};
